import { ChurchHistoryService } from 'src/app/shared/services/church-history.service';
import { NavigationPanelService } from 'src/app/shared/services/navigation-panel.service';
import { AuthService } from '../account/auth.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SimpleTenant } from 'src/app/shared/models/simple-tenant.model';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';
import { TenantService } from 'src/app/tenant/tenant.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  tenant: SimpleTenant = {} as SimpleTenant;
  languages = ['English','Arabic'];
  changingLanguage = false;

  constructor(public globalService: GlobalService,
      private router: Router,
      public identityService: IdentityService, public panels: NavigationPanelService, private authService: AuthService,
      private linkHandler: LinkHandlerService,
      private tenantService: TenantService, private churchHistory: ChurchHistoryService) { }

  async ngOnInit() {
  try {
    this.tenant = await this.tenantService.getSimpleTenant();
    if (!this.tenant.deleted) this.churchHistory.remember(this.tenant.subdomain, this.tenant.name);
    try {const languages=await this.globalService.getLanguages();if(languages?.length)this.languages=[...new Set(languages)];} catch {}
    void this.panels.refresh();
  } catch (err) {
    console.error('Footer tenant load failed', err);
    this.tenant = {} as any; // fallback
  }

  }

  Home() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    const home = this.identityService.authenticated && this.identityService.permissions?.includes('Check-in') ? '/usher/check-in' : '/home';
    setTimeout(() => this.router.navigate([home]), timer);
  }    

  MyProfile() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/myprofile']), timer);
  }  

  Notification() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/notifications']), timer);
  }    

  Calendar() {
    this.globalService.Initialize();
    let calendarUrl = "/admin/cms/calendar/0/0/1";
    let external = false;
    if (this.tenant?.customCalendar && this.tenant.customCalendar.trim() !== "")
    {
      calendarUrl = this.tenant.customCalendar;
      external = true;
    } 
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    if (external == false)
      setTimeout(() => this.router.navigate([ calendarUrl ]), timer);
    else
      setTimeout(() => this.linkHandler.open(calendarUrl), timer);  
  }

  accountLabel(label: string): string {
    const arabic: {[key: string]: string} = {
      Personal: 'شخصي', Profile: 'الملف الشخصي', Reservations: 'الحجوزات', Groups: 'المجموعات',
      Forms: 'النماذج', 'Outreach tasks': 'مهام الافتقاد', 'Switch church': 'تغيير الكنيسة',
      'Sign out': 'تسجيل الخروج', Privacy: 'الخصوصية'
    };
    return this.globalService.isRTL ? arabic[label] || label : label;
  }

  SwitchChurch() {this.goTo('/' + (this.tenant.subdomain || this.globalService.subdomain) + '/switch-tenant');}

  SystemMenu() {this.panels.toggle('system');}
  Language() {this.panels.toggle('language');}
  languageLabel(language: string) {return ({Arabic:'العربية',Spanish:'Español',French:'Français'} as any)[language] || language;}
  languageFlag(language: string) {return ({English:'🇺🇸',Arabic:'🇪🇬',Spanish:'🇪🇸',French:'🇫🇷'} as any)[language] || '🌐';}
  setLanguage(language: string) {
    if(this.changingLanguage)return;
    if(language===this.globalService.currentLanguage){this.panels.close();return;}
    this.changingLanguage=true;localStorage.setItem('Language',language);
    this.globalService.currentLanguage=language;this.globalService.clearCurCache=true;window.location.reload();
  }
  goTo(path: string) {
    this.panels.close(false);
    this.globalService.clearCurCache=true;
    this.globalService.isBack=false;
    this.globalService.datePicker?.close();
    this.globalService.datePicker=null;
    this.router.navigate([path]);
  }
  Logout() {this.panels.close(false);this.globalService.clearCurCache=true;this.globalService.isBack=false;this.authService.logout(1);this.identityService.authenticated=false;this.identityService.permissions=[];void this.panels.refresh();this.router.navigate(['/home']);}
  @HostListener('document:keydown.escape') onEscape() {if(this.panels.panel)this.panels.close();}

  CheckIn() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    if (this.identityService.authenticated == true && this.identityService.permissions?.includes('Check-in'))
      setTimeout(() => this.router.navigate(['/usher/check-in']), timer);
    else
      setTimeout(() => this.router.navigate(['/fast-checkin']), timer);
  }  

  isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      return true;
    }
    return false;
  }
}
